import { useEffect } from "react";

const useScrollToTop = (hash?: string) => {
    useEffect(() => {
        if (!hash) {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 0);
        }
    }, []);

};

export default useScrollToTop;

